export default __webpack_public_path__ + "static/media/upper-back.aae0fbdc.svg";